import { filterGroups } from './emailUtils';

function EmailFilters({ activeTab, filter, onChange }) {
  return (
    <div className="admin-email-filter-list">
      {filterGroups.map((group) => (
        <div className="admin-email-filter-group" key={group.label}>
          <span className="admin-email-filter-heading">{group.label}</span>
          {group.options.map((option) => (
            <button
              className={filter === option.value || activeTab === option.value ? 'is-active' : ''}
              key={option.value}
              onClick={() => onChange(option.value)}
              type="button"
            >
              {option.label}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}

export default EmailFilters;
